import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Modal,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
} from "reactstrap";
import { DataTable, MainLoader } from "../../../../components";
import { toast } from "react-toastify";
import MediaQuery from "react-responsive";
import { layout } from "../../../../common/constants";
import { getProducts } from "../../../../store/product/actions";
import { getServices } from "../../../../store/service/actions";
import { createOffer, uploadOfferImage } from "../../../../store/offer/actions";
import * as columns from "./_columns";
import { FormItem, FormOffer, FormSelectItem } from "./Forms";

class OfferAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
      selectedProducts: [],
      selectedServices: [],
      selectedItem: null,
      modalOpen: false,
      itemModalOpen: false,
      itemType: "",
      counter: 0,
    };

    this.onSubmitOffer = this.onSubmitOffer.bind(this);
    this.onSubmitOfferItem = this.onSubmitOfferItem.bind(this);
    this.onSelectOfferItem = this.onSelectOfferItem.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleItemModal = this.toggleItemModal.bind(this);
    this.changeImage = this.changeImage.bind(this);
    this.optionsFormatterColumnProducts =
      this.optionsFormatterColumnProducts.bind(this);
    this.optionsFormatterColumnServices =
      this.optionsFormatterColumnServices.bind(this);
  }

  componentDidMount() {
    this.props.getProducts({ reset: true });
    this.props.getServices({ reset: true });
  }

  componentWillUnmount() {
    //TODO: reset Offer Add
  }

  componentDidUpdate(prevProps) {
    this.checkOfferCreationSuccess(prevProps);
    this.checkUploadOfferImageSuccess(prevProps);
  }

  checkOfferCreationSuccess(prevProps) {
    if (prevProps.offer == null && this.props.offer != null) {
      const { image } = this.state;

      if (image != null) {
        this.props.uploadOfferImage(this.props.offer.id, image);
        return;
      }

      this.onSuccess();
    }
  }

  checkUploadOfferImageSuccess(prevProps) {
    if (prevProps.imageOffer == null && this.props.imageOffer != null) {
      this.onSuccess();
    }

    if (prevProps.imageError == null && this.props.imageError != null) {
      this.onSuccess("Sin embargo, no se ha podido guardar la foto.");
    }
  }

  onSubmitOffer(values) {
    values.products = this.state.selectedProducts;
    values.services = this.state.selectedServices;
    //values.startDate = moment.utc(new Date(values.startDate));
    //values.expirationDate = moment.utc(new Date(values.expirationDate));

    if (values.products.length + values.services.length > 0) {
      this.props.createOffer(values);
    } else {
      let toastMessage = "No se han agregado productos o servicios";
      toast.error(toastMessage);
    }
  }

  onSubmitOfferItem(values, activeItem) {
    var { selectedProducts, selectedServices, itemType, counter } = this.state;
    if (itemType == "Productos") {
      var products = selectedProducts;
      values.name = activeItem.name;
      values.oid = counter;
      counter++;
      products.push(values);
      this.setState({
        selectedProducts: products,
        modalOpen: false,
        itemModalOpen: false,
        counter: counter,
      });
    } else {
      let services = selectedServices;
      values.name = activeItem.name;
      values.oid = counter;
      counter++;
      services.push(values);
      this.setState({
        selectedServices: services,
        modalOpen: false,
        itemModalOpen: false,
        counter: counter,
      });
    }
  }

  onSelectOfferItem(item) {
    this.setState({ selectedItem: item });
  }

  async toggleModal(type) {
    await this.setState({
      itemType: type,
      modalOpen: !this.state.modalOpen,
    });
    if (!this.state.modalOpen)
      this.setState({
        selectedItem: {
          id: null,
          name: null,
          price: null,
        },
      });
  }

  async toggleItemModal() {
    await this.setState({
      itemModalOpen: !this.state.itemModalOpen,
    });
    if (this.state.itemModalOpen)
      this.setState({
        selectedItem: {
          id: null,
          name: null,
          price: null,
        },
      });
  }

  changeImage(file) {
    this.setState({
      image: file,
    });
  }

  onSuccess(message = "") {
    let toastMessage = `Oferta Creada Satisfactoriamente. ${message}`;
    toast.success(toastMessage);
    this.props.history.push("/administration/offers");
  }

  performDeleteItem(oid, type) {
    var list =
      type == "Productos"
        ? this.state.selectedProducts
        : this.state.selectedServices;
    list = list.filter(function (obj) {
      return obj.oid !== oid;
    });
    if (type == "Productos") {
      this.setState({ selectedProducts: list });
    } else {
      this.setState({ selectedServices: list });
    }
  }

  optionsFormatterColumnProducts(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => this.performDeleteItem(row.oid, "Productos")}
          >
            <i className="fa fa-trash mr-1"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }
  optionsFormatterColumnServices(cell, row) {
    return (
      <UncontrolledButtonDropdown>
        <DropdownToggle size="sm" color="primary">
          <i className="fa fa-bars"></i>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => this.performDeleteItem(row.oid, "Servicios")}
          >
            <i className="fa fa-trash mr-1"></i> Eliminar
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    );
  }

  renderDataTable(columns, data) {
    return (
      <DataTable
        data={data}
        keyField="oid"
        columns={columns}
        loading={this.props.loading}
      />
    );
  }

  render() {
    const columnOptionProducts = {
      dataField: "",
      text: "",
      isDummyField: true,
      formatter: this.optionsFormatterColumnProducts,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };
    const columnOptionService = {
      dataField: "",
      text: "",
      isDummyField: true,
      formatter: this.optionsFormatterColumnServices,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };
    const {
      modalOpen,
      itemModalOpen,
      selectedProducts,
      selectedServices,
      itemType,
    } = this.state;
    const { error, loading, imageLoading } = this.props;

    const isLoading = loading || imageLoading;
    return (
      <div className="animated">
        <Card>
          <CardHeader>Nueva Oferta</CardHeader>
          <CardBody>
            {error && <Alert color="danger">{error}</Alert>}
            <FormOffer
              onSubmitOffer={this.onSubmitOffer}
              toggleModal={this.toggleModal}
              modalOpen={modalOpen}
              itemType={itemType}
              isLoading={isLoading}
              changeImage={this.changeImage}
              selectedServices={this.state.selectedServices}
              selectedProducts={this.state.selectedProducts}
            ></FormOffer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader>Items de Oferta</CardHeader>
          <CardBody>
            {selectedProducts.length > 0 && (
              <Row>
                <Col>
                  <Row>
                    <Col>
                      <Label>
                        <b>Productos</b>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsProductXS(columnOptionProducts),
                          selectedProducts
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsProductSM(columnOptionProducts),
                          selectedProducts
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsProduct(columnOptionProducts),
                          selectedProducts
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
            {selectedServices.length > 0 && (
              <Row>
                <Col>
                  <Row>
                    <Col>
                      <Label>
                        <b>Servicios</b>
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsServiceXS(columnOptionService),
                          selectedServices
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsServiceSM(columnOptionService),
                          selectedServices
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsService(columnOptionService),
                          selectedServices
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>

        <Modal isOpen={modalOpen}>
          <FormItem
            products={this.props.products}
            services={this.props.services}
            selectedItem={this.state.selectedItem}
            itemType={this.state.itemType}
            onSubmitOfferItem={this.onSubmitOfferItem}
            toggleModal={this.toggleModal}
            toggleItemModal={this.toggleItemModal}
          />
        </Modal>

        <Modal isOpen={itemModalOpen}>
          <FormSelectItem
            itemType={this.state.itemType}
            onSubmitItem={this.onSelectOfferItem}
            toggleModal={this.toggleItemModal}
          ></FormSelectItem>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { offer, error, loading } = state.offer.newOffer;
  const { uploadImageOffer } = state.offer;
  const { productList } = state.product;
  const { serviceList } = state.service;

  return {
    offer,
    error,
    loading,

    imageOffer: uploadImageOffer.imageUrl,
    imageError: uploadImageOffer.error,
    imageLoading: uploadImageOffer.loading,

    products: productList.products,
    services: serviceList.services,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProducts,
      getServices,
      createOffer,
      uploadOfferImage,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferAdd);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferAdd/OfferAdd.js